<template>
  <Suspend @close="close" ref="suspendRef"></Suspend>
</template>
<script>
import Suspend from "@/components/Suspend/index.vue";
import { transferRoleInfo, registReturnGameFunction, getKsTaskList, WebFragmentOnResume, setUserInfo } from '@/bridge/AppJsBridge'
import { mapState } from 'vuex';
import { buryReportV2 } from "@/libs/business/account";
import { getStorage, setStorage } from "@/libs/utils";
import user from "@/store/modules/user";
import { callhandler } from "@/bridge/jsBridge";
// import { createApp } from 'vue';
// const app = createApp(App);
// app.config.devtools = true;  // 强制开启



export default {
  data() {
    return {
    
    }
  },
  async mounted() {
    this.$store.dispatch('user/getCacheState');
    this.bridgeInit();
    // 在初始化后隐藏福利和公众号标签
    this.$nextTick(() => {
      this.hideSpecificTabs(['welfare', 'officialWechat']);
    });
    // 使用MutationObserver监听DOM变化，隐藏账号注销
    this.hideWriteOffOption();
    setTimeout(() => {
      this.handleTab();
    }, 500)
  },
  computed: {
    ...mapState({
      userState: state => state.user
    })
  },
  components: {
    Suspend
  },
  created() {
    // test((data) => {
    //   console.log('test回调被触发:', data);
    //   // 这里可以处理回调数据
    // });
  },
  methods: {
    bridgeInit() {
      transferRoleInfo(async (data, cb) => {
        data = JSON.parse(data);
        console.log('role info:', data);
        if (data.role_id && data.server_id && data.role_id != 0) {
          this.$store.commit('voucher/CHANGE_STATE', { showList: data });
          this.$store.commit('redEnvelope/CHANGE_STATE', {
            role: {
              ...data,
              server_num: data.server_id
            }
          })
          this.$store.commit('suspend/CHANGE_STATE', { role: data })
          this.$store.dispatch('activity/handleActivityShow', data);
          // 获取礼包数据
          this.$store.dispatch('suspend/getGiftData');
          // 判断福利红点用
          const appkey = this.$getStorage('appkey');
          const user_id = this.$getStorage('user_id');
          this.$store.dispatch('redEnvelope/getReceiveInfo', {
            params: {
              appkey,
              user_id,
              server_num: data.server_id,
              role_id: data.role_id,
            },
            fail: () => {},
          });
        }
      }),

      setUserInfo((data) => {
        let userData = data;
        if (typeof data === 'string') {
          try {
            userData = JSON.parse(data);
          } catch (e) {
            console.error('解析用户信息失败:', e);
            return;
          }
        }
        
        // 检查是否有有效的用户信息
        if (userData.status === 'not_logged_in') {
          console.warn('用户未登录，无法获取用户信息');
          return;
        }
        // console.log('处理用户信息:', userData);
        if (userData.user_id && userData.user_name) {
          // 有效的用户信息，更新store - 注意字段映射
          const userInfo = {
          user_id: userData.user_id,
          username: userData.user_name,
          session_id: userData.session_id,
          thirdLoginVisible: false,
          loginVisible: false,
          cellLoginVisible: false,
          quickRegisterVisible: false,
          cellRegisterVisible: false,
          suspendVisible: true
        };
          setStorage('user_id', userInfo.user_id);
          setStorage('username', userInfo.username);
          setStorage('access_token', userInfo.session_id);
          setStorage('session_id', userInfo.session_id);
          setStorage('appkey', userData.appkey || ''); // 确保appkey存在
          setStorage('appKey', userData.appkey || ''); // 确保appkey存在
          setStorage('device_info', userData.device_info || ''); // 确保device_info存在
          setStorage('extra_data', userData.extra_data || ''); // 确保extra_data存在
      
          this.$store.commit('user/CHANGE_STATE', userInfo);

          console.log('--- registJSInitial start ---')
          const { jsDataStorage, third_sdk_status } = userData;
        // 存储传过来的信息
          this.$store.commit('user/CHANGE_STATE', {
            sdk_version: userData.sdk_version,
            device_info: userData.device_info,
            appkey: userData.jh_app_id,
            channel: userData.jh_channel,
            extra_data: JSON.stringify(userData.extra_data),
            game_version: userData.game_version,
            login_status: jsDataStorage || '',
            third_sdk_status: third_sdk_status || '',
            isEmulator: userData.isEmulator,
            isInstallWeChat: userData.isInstallWeChat,
            isInstallAlipay: userData.isInstallAlipay,
          });

          // 缓存信息
          const cacheList = [
            'login_status',
            'sdk_version',
            'device_info',
            'appkey',
            'channel',
            'extra_data',
            'device_info',
            'game_version',
            'third_sdk_status',
            'isEmulator',
            'isInstallWeChat',
            'isInstallAlipay'
          ];
          this.$store.dispatch('user/cacheState', cacheList);
          
        } else {
          console.warn('用户信息不完整:', userData);
        }
      }),
      /** $$ ks活动临时 */
      getKsTaskList((data) => {
        console.log('getKsTaskList回调被触发:', data);
        const _data = JSON.parse(data);
        console.log(44, _data);
        this.$store.commit('ks/CHANGE_STATE', { taskInitList: _data, taskInitState: true });
        this.$refs.suspendRef.getRealDay(_data);
      })
      /** -------- */
      WebFragmentOnResume(() => {
        this.$store.commit('suspend/CHANGE_STATE', { boxDownLoadShow: false })
      })
    },
      // 隐藏特定标签的方法
      hideSpecificTabs(tabTypes) {
        // 获取当前tabs
        const currentTabs = [...this.$store.state.suspend.tabs];
        
        // 更新需要隐藏的标签
        const updatedTabs = currentTabs.map(tab => {
          if (tabTypes.includes(tab.type)) {
            return { ...tab, show: false };
          }
          return tab;
        });
        
        // 提交到Vuex
        this.$store.commit('suspend/CHANGE_STATE', { tabs: updatedTabs });
        
        // 如果当前选中的是这些标签之一，切换到其他可见标签
        const currentActiveTab = this.$store.state.suspend.activeTab;
        if (currentActiveTab && tabTypes.includes(currentActiveTab.type)) {
          const firstVisibleTab = updatedTabs.find(tab => tab.show === true);
          if (firstVisibleTab) {
            this.$store.commit('suspend/CHANGE_STATE', { activeTab: firstVisibleTab });
          }
        }
      },
      hideWriteOffOption() {
      // 创建MutationObserver监听DOM变化
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // 查找账号注销元素
            const writeOffElements = document.querySelectorAll('[class*="cell"]');
            writeOffElements.forEach(element => {
              if (element.textContent.includes('账号注销')) {
                element.style.display = 'none';
              }
            });
          }
        });
      });
      
      // 开始观察
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // 存储observer以便后续清理
      this.writeOffObserver = observer;
    },
    
    // 在组件销毁时清理
    beforeDestroy() {
      if (this.writeOffObserver) {
        this.writeOffObserver.disconnect();
      }
    },
    // 从 活动计划&闪页 跳转到活动悬浮球指定页面
    handleTab() {
      const { reRoute } = this.$route.query;
      if (reRoute) {
        const tabs = this.$store.state.suspend.tabs;
        const reRouteTab = tabs.find(item => item.type == reRoute);
        if (reRouteTab && reRouteTab.show == true) {
          this.$store.commit('suspend/CHANGE_STATE', { activeTab: reRouteTab });
          this.reRouteReport(reRouteTab.type)
        }
      }
    },
    reRouteReport(type) {
      const uploadCache = this.$getStorage('buryport') || {};
      if (type === 'welfare') {
        buryReportV2('SDK_MENU_PROFIT', { menu_name: "福利", ...uploadCache })
      }
    },
    close() {
      this.$refs.suspendRef.setSideBarState(false);
      setTimeout(() => {
        registReturnGameFunction(null);
      }, 800);
    }
  }
}
</script>